import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { dcAttributeTemplate } from './model/dcAttributeTemplate.model';
import { dcElementTemplate } from './model/dcElementTemplate.model';
import { dcElementTemplateHeader } from './model/dcElementTemplateHeader.model';
import { dcTag } from './model/dcTag.model';
import { dcTreeNode } from './model/dcTreeNode.model';
import { dcActionInfo } from './model/response/dcActionInfo.model';

@Injectable()
export class ElementTemplateService {
  constructor(private httpService: HttpService) {}

  getAttributeTemplates(ElementTemplateVersionID: number): Observable<dcAttributeTemplate[]> {
    return this.httpService.get(
      `ElementTemplate/GetAttributeTemplates?ElementTemplateVersionID=${ElementTemplateVersionID}`
    );
  }

  getAttributeTemplatesByTemplateOrType(treeNode: dcTreeNode): Observable<dcAttributeTemplate[]> {
    return this.httpService.post<dcAttributeTemplate[]>(
      'ElementTemplate/GetAttributeTemplatesByTemplateOrType',
      treeNode
    );
  }

  getDerivedTemplate(elementTemplateID: number): Observable<dcElementTemplate[]> {
    return this.httpService.get<dcElementTemplate[]>(
      `ElementTemplate/GetDerivedTemplate?elementTemplateID=${elementTemplateID}`
    );
  }

  getElementTemplateByTags(templateTags: dcTag[]) {
    return this.httpService.post<dcActionInfo<dcElementTemplateHeader>>(
      'ElementTemplate/GetElementTemplateByTags',
      templateTags
    );
  }

  saveElementType(elementTypeName: string) {
    return this.httpService.post<any>(`V1/ElementTemplate/Type/${elementTypeName}`, {});
  }
}
